import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, onUnmounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RoomTime',
  setup(__props) {

const meetingTime = ref(0);
let intervalId: any = null;

const formattedTime = computed(() => {
  const minutes = Math.floor(meetingTime.value / 60);
  const seconds = meetingTime.value % 60;
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
});

function startTimer() {
  intervalId = setInterval(() => {
    meetingTime.value += 1;
  }, 1000);
}

onMounted(() => {
  startTimer();
});

onUnmounted(() => {
  intervalId && clearInterval(intervalId);
});

return { __sfc: true,meetingTime, intervalId, formattedTime, startTimer }
}

})